// extracted by mini-css-extract-plugin
module.exports = {"tabHeader":"index__1YCB_","active":"index__3c_oZ","barAnimated":"index__2QTla"};